import UserRow from './UserRow';
import AxiosClient from '../../assets/AxiosClient.js';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Loader from '../../assets/tools/Loder/loader';

const Users = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 40;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await AxiosClient.get('/Users');
        const { users } = await response.data;
        setUsers(users);
        setFilteredUsers(users);
        setLoading(true);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const filtered = users.filter(
      (user) =>
        user.first_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        user.last_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        user.email.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredUsers(filtered);
    setCurrentPage(1);
  }, [searchQuery, users]);

  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <div className="m-3">
        <Link className="btn btn-dark m-2" to="Add">
          <i className="material-icons">person_add</i> | Add new User
        </Link>
      </div>

      <div className="m-3">
        <input
          type="text"
          className="form-control"
          placeholder="Search by name or email..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="card-body px-0 pb-2">
        <div className="p-0 text-center">
          <table className="table mb-0">
            <thead>
              <tr>
                <th className="text-uppercase font-weight-bolder opacity-7">Full name</th>
                <th className="text-uppercase font-weight-bolder opacity-7 ps-2">Title</th>
                <th className="text-uppercase font-weight-bolder opacity-7 ps-2">Action</th>
              </tr>
            </thead>
            {loading ? (
              <tbody>
                {currentUsers.map((user) => (
                  <UserRow key={user.id} name={`${user.first_name} ${user.last_name}`} title={user.role} id={user.id} />
                ))}
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td colSpan="3"><Loader label="Loading users..." /></td>
                </tr>
              </tbody>
            )}
          </table>
        </div>
      </div>
      
      <div className="pagination">
        {Array.from({ length: Math.ceil(filteredUsers.length / usersPerPage) }, (_, i) => (
          <button key={i} onClick={() => paginate(i + 1)} className={`btn ${currentPage === i + 1 ? 'btn-primary' : 'btn-light'} mx-1`}>
            {i + 1}
          </button>
        ))}
      </div>
    </>
  );
};

export default Users;